let dateFoundation =  document.querySelectorAll(".foundation-news-date");
let headFoundation =  document.querySelectorAll(".foundation-news-head");
let descFoundation =  document.querySelectorAll(".foundation-news-desc");
let readmoreFoundation =  document.querySelectorAll(".foundation-news-readmore");

if( headFoundation.length > 0 && descFoundation.length > 0 ){
    const xhr = new XMLHttpRequest();
    xhr.onload = function() {
        if (xhr.status === 200) {
            let indexNews = headFoundation.length;
            let date;
            const newsFoundation = JSON.parse(xhr.response).news.data.slice(0, indexNews);

            newsFoundation.forEach((info , index)=>{
                date = info.publishedFrom.split("T")[0].split("-");
                dateFoundation[index].innerHTML = date[2]+"."+date[1]+"."+date[0]+" r.";
                headFoundation[index].innerHTML = info.title;
                descFoundation[index].innerHTML = info.lead;
                readmoreFoundation[index].href = "https://media.enea.pl/pr/" + info.entityId + "/"+ info.handle;
            });
        }
    }
    xhr.open("GET", "/api/posts", true);
    xhr.send();
}
